module.exports = __webpack_public_path__ + "static/img/10020 (1).254eb04.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10020 (1).webp
// module id = k+0C
// module chunks = 14